import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useStyles from './LocationFlorist.styles';
import FloristSearchGallery from '../FloristSearchGallery/FloristSearchGallery';
const LocationFlorist = (props) => {
    const { location, localFlorists } = props;
    const { onLoadMore, hasMore } = props;
    const { classes } = useStyles();
    return (_jsxs(_Fragment, { children: [location && _jsxs("h2", { className: classes.floristLocation, children: ["Florists in ", location] }), !!(localFlorists === null || localFlorists === void 0 ? void 0 : localFlorists.length) && (_jsx(FloristSearchGallery, { floristSearchResults: localFlorists, onLoadMore: onLoadMore, hasMore: hasMore, isFromLocalFlorist: true }))] }));
};
export default LocationFlorist;
